// extracted by LIB_CSS_EXTRACT_LOADER
import "./dot-background_module.css"
export default {"root":"root-yMOWPb","dot":"dot-LGut9V"};